var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageNotFoundImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 282.349,
    height: 221.571,
    viewBox: "0 0 282.349 221.571",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1445",
    transform: "translate(-131.147 -220.509)",
    opacity: 0.651
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(131.147 220.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2005",
    "data-name": "Path 2005",
    d: "M419.544,457.283c-.25,1.706-.461,2.767-.513,3.01a72.4,72.4,0,0,1-6.276,17.694v0q-1.217,2.408-2.6,4.747a90.808,90.808,0,0,1-9.227,12.812q-3.136,3.667-6.685,7.108c-10.243,9.965-22.861,18.488-36.706,25.382q-3.9,1.945-7.927,3.71A199.12,199.12,0,0,1,323.44,541.1q-2.772.78-5.555,1.477c-3.221.811-6.456,1.54-9.685,2.181q-6.543,1.306-13.038,2.15c-5.538.721-11.026,1.179-16.408,1.377a186.759,186.759,0,0,1-19.272-.326c-3.291-.215-6.63-.52-10-.912a.03.03,0,0,1-.024,0q-4.478-.515-9.015-1.234c-.825-.132-1.651-.27-2.479-.409-5.6-.96-11.217-2.16-16.776-3.606-.1-.024-.2-.049-.3-.08a1.446,1.446,0,0,1-.166-.042q-.234-.057-.468-.125c-4.952-1.311-9.844-2.819-14.629-4.532-3.367-1.2-6.682-2.51-9.917-3.922q-2.309-1-4.56-2.081-2.06-.983-4.071-2.028a107.1,107.1,0,0,1-21.471-14.442,80.356,80.356,0,0,1-7.982-8.069,66.355,66.355,0,0,1-9.421-14.335,59.943,59.943,0,0,1-3.142-7.9q-.536-1.68-.981-3.419a73.052,73.052,0,0,1-2.191-16.165q-.052-1.961,0-3.939a75.566,75.566,0,0,1,1.578-13.655c2.493-11.841,7.94-22.8,16.668-30.1,15.028-12.587,38.229-13.045,52.6-11.845,5.6.468,9.861,1.186,11.775,1.54,2.847.524,5.635,1.172,8.454,1.852,10.447,2.514,21.335,5.42,37.188,3.637a114.869,114.869,0,0,0,17.934-3.811,155.684,155.684,0,0,0,22.993-8.221l.988-.451c.843-.392,1.654-.777,2.448-1.162.2-.1.406-.2.6-.295,1.6-.784,3.107-1.557,4.549-2.313h.007l.153-.083c.2-.1.392-.2.586-.309a.288.288,0,0,0,.055-.031c2.1-1.106,4.074-2.178,6-3.194.4-.212.8-.42,1.193-.624.277-.142.555-.288.832-.427.191-.1.381-.194.569-.291h0c1.158-.583,2.309-1.144,3.485-1.678,1.827-.836,3.7-1.605,5.7-2.3,1.574-.551,3.221-1.051,4.983-1.5,17.462-4.442,43.576-3.024,60.188,12.351,13.53,12.528,16.8,30.649,17.053,44.165a96.084,96.084,0,0,1-.936,15.3Z",
    transform: "translate(-138.149 -326.829)",
    fill: "#eef0f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2006",
    "data-name": "Path 2006",
    d: "M308.246,502.316v97.033a185.109,185.109,0,0,1-29.446,3.526c-25.319.926-56.731-3.721-83.046-15.184a135.049,135.049,0,0,1-12.784-6.366s0,0-.007,0q-3.76-2.138-7.285-4.5-3.22-2.159-6.21-4.511-1.961-1.55-3.814-3.18c-9.515-8.374-16.772-18.426-20.545-30.3-.354-1.12-.683-2.257-.978-3.415a72.9,72.9,0,0,1-2.195-16.165v-3.943a75.53,75.53,0,0,1,1.578-13.651H168.93v35.046h4.352V466.83h26.994V571.97h16.545V485.117l64.436,32.216V502.316a12.628,12.628,0,0,1,12.629-12.628h1.733a12.628,12.628,0,0,1,12.627,12.627Zm111.343-.765v10.323c-.247,1.7-.459,2.764-.511,3.008-8.716,41.112-53.954,70.442-101.146,82.288V477.28h26.992v90.555h4.354V513.511l26.991-11.852v-.108a21.659,21.659,0,1,1,43.319,0Z",
    transform: "translate(-138.195 -381.419)",
    fill: "#e3e6e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2007",
    "data-name": "Path 2007",
    d: "M530.277,670.134a90.716,90.716,0,0,1-9.229,12.812v-7.659c0-2.848,3.9-5.155,8.711-5.155ZM360.572,733.211q-1.238-.195-2.478-.409a193.833,193.833,0,0,1-32.342-8.38l15.772-42.313Z",
    transform: "translate(-258.274 -514.228)",
    fill: "#c2cacd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2008",
    "data-name": "Path 2008",
    d: "M220.844,700.727c-13.2-6.3-24.883-14.428-33.523-24.541l12.188-32.7ZM442.449,647.7q-1.214,2.41-2.6,4.746a90.765,90.765,0,0,1-9.229,12.812q-3.137,3.667-6.684,7.108c-18.233,17.735-43.978,30.9-70.8,38.446q-2.77.777-5.552,1.477-4.835,1.214-9.688,2.181-6.54,1.3-13.038,2.15a17.483,17.483,0,0,1,1.986-1.412c4-2.432,8.664-3.721,12.355-6.593-1.913-1.46-.4-4.508,1.325-6.184a40.334,40.334,0,0,1,14.425-8.989c-.867-6.769,6.565-13.149,13.124-11.269a6.988,6.988,0,0,1,13.67-1.86,21.871,21.871,0,0,1,1.973-6.847,2.37,2.37,0,0,1,4.366.243.282.282,0,0,0,.013.039c2.175-4.377,9.015-5.395,12.37-1.838-1.17-4.358,4.079-8.905,8.226-7.126-1.99-2.92-2.527-7-.65-9.994s6.435-4.185,9.166-1.942c-1.939-3.307.5-8.24,4.31-8.7,1.942-.236,3.869.512,5.827.563a5.317,5.317,0,0,0,2.874-.769,5.256,5.256,0,0,1,6.727.726,14.025,14.025,0,0,1,2.688,4.5C440.6,648.7,441.534,648.194,442.449,647.7Z",
    transform: "translate(-167.843 -496.536)",
    fill: "#d9dee0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2009",
    "data-name": "Path 2009",
    d: "M352.639,336.13c-11.668-2.513-24.023-7.343-29.767-17.805-2.063-3.757-3.1-8.348-1.587-12.356,2.036-5.384,8.037-8.227,13.731-9.055a33.969,33.969,0,0,1,20.751,3.638c8.647,4.628,15.581,13.125,25.293,14.494,7.429,1.046,14.642-2.389,21.8-4.643s15.909-3.014,21.288,2.216a6.235,6.235,0,0,1,1.625,3.592c1.049,5.721-4.618,10.971-6.667,12.87-2.8,2.592-9.293,7.488-29.624,9.127C378.542,339.087,367.387,339.306,352.639,336.13Z",
    transform: "translate(-254.885 -270.198)",
    fill: "#eef0f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2010",
    "data-name": "Path 2010",
    d: "M200.852,354.573H132.584a10.744,10.744,0,0,1,14.273-14.893,16.525,16.525,0,1,1,31.591,7.982C185.907,350.031,193.223,352.924,200.852,354.573Z",
    transform: "translate(-131.147 -288.417)",
    fill: "#e0e3e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2011",
    "data-name": "Path 2011",
    d: "M754.3,442.405h36.736a5.781,5.781,0,0,0-7.679-8.015,8.893,8.893,0,1,0-17,4.3C762.341,439.959,758.4,441.517,754.3,442.405Z",
    transform: "translate(-538.224 -354.881)",
    fill: "#e3e6e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2012",
    "data-name": "Path 2012",
    d: "M657.553,261.6H750.7a14.659,14.659,0,0,0-19.474-20.319,22.547,22.547,0,1,0-43.1,10.891C677.943,255.394,667.962,259.344,657.553,261.6Z",
    transform: "translate(-475.024 -220.509)",
    fill: "#e0e3e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2013",
    "data-name": "Path 2013",
    d: "M368.741,830.884l-.1.021c-1.071-.035-2.153-.076-3.239-.128-.5-.024-1-.052-1.494-.08-.44-.024-.881-.049-1.321-.076-.624-.038-1.252-.08-1.879-.125q-1.129-.083-2.261-.177c-.4-.031-.791-.066-1.189-.1-.714-.062-1.429-.132-2.146-.2-.479-.049-.957-.1-1.439-.149q-1.2-.125-2.4-.267-2.408-.281-4.834-.628c-.357-.049-.711-.1-1.065-.153q-1.337-.192-2.677-.406c-.413-.066-.825-.135-1.238-.2s-.825-.139-1.241-.208c-.361-.062-.718-.125-1.078-.191q-2.725-.478-5.447-1.037l-.392-.083c-.288-.059-.579-.118-.867-.18q-1.467-.307-2.933-.641c-.579-.132-1.155-.264-1.73-.4-.4-.09-.8-.187-1.2-.284-.489-.118-.974-.236-1.463-.361s-.971-.243-1.456-.371-.971-.253-1.456-.381c-.971-.26-1.938-.524-2.9-.8-.472-.132-.947-.27-1.418-.409q-.739-.213-1.477-.437-3.589-1.082-7.119-2.313c-.215-.073-.43-.149-.645-.222l-.759-.27q-2.4-.858-4.754-1.782v0c-.354-.135-.7-.274-1.054-.416-.083-.035-.163-.066-.243-.1-.485-.194-.967-.392-1.449-.589q-.858-.359-1.709-.721c-.094-.038-.187-.08-.277-.121l4.327,0h.191l.08,0h0l29.383-.007h0l.482,0h.78l5.357,0h.01l.5,0h.083l17.726,0,3.988,0h.87l.385,0h.211l3.974,0h.444v.017l.628,6.033.624,6.037,0,.024V828l.055.565v0Z",
    transform: "translate(-240.399 -609.431)",
    fill: "#4e595f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2014",
    "data-name": "Path 2014",
    d: "M367.184,815.87l-1.893.139-2.736.2-1.255.09-21.467,1.574-1.259.094-4.924.361-1.259.094-23.111,1.692c-.215-.073-.43-.149-.645-.222l-.759-.271q-2.4-.858-4.754-1.782v0c-.354-.135-.7-.274-1.054-.416-.083-.035-.163-.066-.243-.1-.485-.194-.967-.392-1.449-.589q-.858-.359-1.709-.721c-.094-.038-.187-.08-.277-.121l4.327,0h.27l29.39-.007h7.212l17.726,0,3.988,0Z",
    transform: "translate(-240.399 -609.431)",
    fill: "#343b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2015",
    "data-name": "Path 2015",
    d: "M397.724,826.739c-.42-.087-.839-.173-1.259-.264l-.042-8.093-.014-2.413v-.159l1.259.007v.153l.014,2.32.024,4.952.007,1.29Z",
    transform: "translate(-304.431 -609.392)",
    fill: "#343b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2016",
    "data-name": "Path 2016",
    d: "M341.422,824.508a4.278,4.278,0,0,0,3.1-1.123c2.484-2.375,1.375-7.621,1.327-7.843l-1.231.259c.01.047,1.006,4.778-.971,6.666-.873.832-2.272,1-4.157.484l-.319,1.221A8.771,8.771,0,0,0,341.422,824.508Zm-32.015-6.886c-.433-.166-.867-.34-1.3-.517-.035-.739-.09-1.227-.1-1.311a.035.035,0,0,1,0-.014l.992-.111h.014l.253-.028c0,.007,0,.017,0,.028v0c0,.028.01.066.014.121C309.321,816.082,309.383,816.74,309.407,817.621Zm64.328,10.831a5.365,5.365,0,0,0,1.109-.116l-.255-1.233a3.162,3.162,0,0,1-2.842-.648c-3.057-2.578-2.908-10.73-2.906-10.812l-1.252-.037c-.008.36-.158,8.848,3.36,11.813a4.239,4.239,0,0,0,2.786,1.033Z",
    transform: "translate(-246.684 -609.216)",
    fill: "#343b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2017",
    "data-name": "Path 2017",
    d: "M328.136,581.528H307.158l-.024,2.555-.035,4.064-.007.856-.024,2.621,0,.479-.055,6.359-.01.86-.038,4.424v0l-.017,2.2-.024,2.833-.007.856-.024,2.563-.049,5.489v.052l-.014,1.359-.007.856-.024,2.8,0,.593v.139H238.27c-.094-.038-.187-.08-.277-.121h0q-1.5-.645-2.975-1.325V582.631H205.936l.09-.954.09-.912.964-10.094.09-.919.964-10.09.087-.915.274-2.843a38.234,38.234,0,0,1,1.6-7.9c.118-.375.239-.749.371-1.12q.13-.375.27-.749a38,38,0,0,1,4.352-8.353q.889-1.29,1.879-2.5c.146-.18.295-.357.447-.534a37.972,37.972,0,0,1,5.6-5.4c.187-.153.378-.3.572-.444a38.169,38.169,0,0,1,10.673-5.68c.173-.062.35-.121.527-.177a38.524,38.524,0,0,1,11.938-1.9h54.557a23.8,23.8,0,0,1,10.236,2.3c.236.111.472.229.7.35a.03.03,0,0,1,.021.01,23.933,23.933,0,0,1,11,11.824,23.053,23.053,0,0,1,1.006,2.833c.069.236.132.475.194.714a24.038,24.038,0,0,1,.652,3.967l.374,4.7.062.808.066.822v.024l.638,8.048.066.808.083,1.071v0l.017.194.6,7.628.066.8.7,8.9.062.8Z",
    transform: "translate(-180.003 -416.91)",
    fill: "#98a4aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2018",
    "data-name": "Path 2018",
    d: "M361.58,767.91l-4.4.593-.017,0-.212.028-.791.107h-63.1c-.094-.038-.187-.08-.277-.121h0q-1.5-.645-2.975-1.325V746.238l2.171-2.878.954,7a15.268,15.268,0,0,0,13.9,13.152Z",
    transform: "translate(-234.788 -562.064)",
    fill: "#76878f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2019",
    "data-name": "Path 2019",
    d: "M370.877,406.244l17.206,6.954c4.42,29.679-8.226,28.3-8.226,28.3l0,4.537a9.508,9.508,0,0,1-10.825,9.411h0a9.509,9.509,0,0,1-8.1-10.733l2.706-19.376-3.381-.472h0a5.177,5.177,0,0,1-4.41-5.845h0q.039-.277.1-.555a6.184,6.184,0,0,1,7.431-4.612l1.757.411Z",
    transform: "translate(-277.896 -341.841)",
    fill: "#dde1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2020",
    "data-name": "Path 2020",
    d: "M362.084,437.753a3.424,3.424,0,0,1,.633-2.733c.639-.62,1.736-.763,3.264-.428l.208-.941c-1.866-.409-3.261-.18-4.145.683a4.335,4.335,0,0,0-.9,3.6Z",
    transform: "translate(-281.343 -359.617)",
    fill: "#bfc7cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2021",
    "data-name": "Path 2021",
    d: "M430.716,457.394l-2.452-6.93-.908.321,2.142,6.057-3.789,1.506.355.895Z",
    transform: "translate(-323.572 -370.728)",
    fill: "#bfc7cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2022",
    "data-name": "Path 2022",
    d: "M417.862,440.3c0,.683.328,1.237.725,1.237s.72-.559.718-1.241a1.877,1.877,0,0,0-.042-.4,1.387,1.387,0,0,0-.21-.534,6.809,6.809,0,0,0-.884-.074,1.238,1.238,0,0,0-.239.484,2.009,2.009,0,0,0-.068.531Zm-13.047-4.884a.271.271,0,0,1,.243-.3l5.368-.592a1.207,1.207,0,0,1,1.279.823l.084.259a.771.771,0,0,1-.856,1l-5.889-.954A.272.272,0,0,1,404.815,435.416Zm17.281.948a.237.237,0,0,0-.189-.277l-4.646-.9a1.057,1.057,0,0,0-1.175.627l-.093.22a.674.674,0,0,0,.676.936l5.21-.412A.237.237,0,0,0,422.1,436.364Z",
    transform: "translate(-309.921 -360.312)",
    fill: "#4e595f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    d: "M407.77,510.088a16.217,16.217,0,0,1-9.247-5.888c2.746,1.362,9.249,1.292,9.249,1.292Z",
    transform: "translate(-305.812 -405.831)",
    fill: "#bfc7cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    "data-name": "Path 2024",
    d: "M507.217,370.965a6.955,6.955,0,0,0-4.636-.423,1.326,1.326,0,0,0-.912,1.8l.01.024a1.348,1.348,0,0,0,1.54.777,3.731,3.731,0,0,1,2.413.229,2.279,2.279,0,0,1,1.224,3.235c-.974,2.1-4.643,2.15-6.536,4.7a1.562,1.562,0,0,0,.6,2.347,1.539,1.539,0,0,0,1.907-.482c1.765-2.5,5.749-2.268,7.192-5.368C511.409,374.824,510.091,372.3,507.217,370.965Zm-7.223,14.643a2.367,2.367,0,1,0,1.044,3.107,2.267,2.267,0,0,0-1.044-3.107Z",
    transform: "translate(-369.835 -318.377)",
    fill: "#4e595f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    "data-name": "Path 2025",
    d: "M417.374,484.414l.289-.818a29.833,29.833,0,0,0-6.475-1.5l-.1.862a28.875,28.875,0,0,1,6.287,1.456Z",
    transform: "translate(-314.019 -391.391)",
    fill: "#bfc7cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2026",
    "data-name": "Path 2026",
    d: "M421.123,446.829c.011,0,.021,0,.033,0l5.024.249a.343.343,0,1,0,.035-.685l-5.024-.249a.343.343,0,0,0-.067.682Zm-8.342-.124c0,.682.328,1.236.725,1.236s.719-.558.718-1.241a1.873,1.873,0,0,0-.042-.4,1.393,1.393,0,0,0-.208-.535,6.94,6.94,0,0,0-.885-.074,1.249,1.249,0,0,0-.239.485A2,2,0,0,0,412.781,446.706Z",
    transform: "translate(-315.126 -367.61)",
    fill: "#4e595f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2027",
    "data-name": "Path 2027",
    d: "M406.89,445.322c.011,0,.022,0,.033,0l5.024.249a.343.343,0,0,0,.035-.685l-5.024-.249a.343.343,0,0,0-.067.682Z",
    transform: "translate(-311.087 -366.923)",
    fill: "#4e595f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    d: "M277.133,618.119,269.1,642.29l8.037-8.834Z",
    transform: "translate(-221.263 -480.249)",
    fill: "#76878f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    d: "M326.406,560.949l-4.314,3.086-9.7-6.935-9.7,6.935L293,557.1l-9.7,6.935-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-9.7-6.935-7.035,5.031-.087.915,7.122-5.094,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,4.379-3.131Zm.77,9.705-5.083,3.634-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-9.7-6.935-8.085,5.784-.09.919,8.176-5.85,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,5.149-3.682Zm.77,9.705-5.853,4.185-9.7-6.935-9.7,6.935L293,577.61l-9.7,6.935-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-9.7-6.935-9.14,6.54-.09.912,9.23-6.6,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.935,9.022,6.453.673.482.673-.482,5.243-3.748Zm-3.526-38.5-2.327,1.664-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-7.538-5.392c-.153.177-.3.354-.447.534l7.986,5.711,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,2.521-1.8C324.551,542.339,324.488,542.1,324.419,541.864Zm1.221,9.383-3.547,2.535-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-9.7-6.935-4.789,3.426c-.132.371-.253.746-.371,1.12l5.16-3.693,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935L293,547.7l9.7,6.935,9.7-6.935,9.7,6.935,3.61-2.58Zm-22.941,53.8-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-9.333-6.675v.853l9.334,6.675,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,4.47-3.2.01-.86Zm9.716-77.844,5.555,3.97A24,24,0,0,0,312.415,527.207Zm-9.716,6.068L293,526.34l-9.7,6.935-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-9.56-6.834-.139-.1-.388.277-9.307,6.658-1.366-.978c-.194.146-.385.291-.572.444l1.938,1.387,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.931c-.232-.121-.468-.239-.7-.35Zm0,92.283-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-9.333-6.675v.853l9.334,6.675,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,4.289-3.069.007-.856Zm0-10.253L293,608.37l-9.7,6.935-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-9.333-6.675v.853l9.334,6.675,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,4.383-3.135.007-.856Zm0-20.507-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-9.7-6.935-9.7,6.935-9.333-6.675v.853l9.334,6.675,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,9.7-6.935,9.7,6.935,4.563-3.263.007-.856Z",
    transform: "translate(-180.173 -420.294)",
    fill: "#76878f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2986",
    "data-name": "Rectangle 2986",
    width: 0.764,
    height: 19.248,
    transform: "translate(55.487 134.434)",
    fill: "#76878f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    d: "M518.24,695.257H497.259l-.317,36.166a5.747,5.747,0,0,0,5.747,5.8h0a15.552,15.552,0,0,0,15.552-15.552Z",
    transform: "translate(-370.104 -530.64)",
    fill: "#dde1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    d: "M535.194,695.257l-12.3,3.253,1.367-3.253Z",
    transform: "translate(-387.058 -530.64)",
    fill: "#bfc7cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    "data-name": "Path 2032",
    d: "M509.157,716.035a28.719,28.719,0,0,1-8.268,18.87,6.752,6.752,0,0,1-3.857,1.958l.136-13.307.271.063c-.092-.046-.181-.09-.271-.132l.069-6.869c1.6.317,2.731.578,2.821.6q-1.524-.6-2.815-1.153l.074-7.4c3.235.046,6.123.3,6.123.3l1.17.407A6.736,6.736,0,0,1,509.157,716.035Z",
    transform: "translate(-370.163 -539.401)",
    fill: "#bfc7cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2987",
    "data-name": "Rectangle 2987",
    width: 4.311,
    height: 41.487,
    rx: 2.156,
    transform: "translate(80.458 120.271) rotate(10.767)",
    fill: "#b5bec2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2988",
    "data-name": "Rectangle 2988",
    width: 7.52,
    height: 28.653,
    rx: 3.76,
    transform: "translate(76.485 132.58) rotate(10.767)",
    fill: "#4e595f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_486",
    "data-name": "Ellipse 486",
    cx: 14.218,
    cy: 14.218,
    r: 14.218,
    transform: "translate(69.875 98.485)",
    fill: "#b5bec2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_487",
    "data-name": "Ellipse 487",
    cx: 11.672,
    cy: 11.672,
    r: 11.672,
    transform: "translate(72.421 101.032)",
    fill: "#4e595f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    "data-name": "Path 2033",
    d: "M347.114,532.038a.79.79,0,0,1-.61-.549,9.7,9.7,0,0,1,5.786-11.865.791.791,0,0,1,.572,1.476,8.119,8.119,0,0,0-4.844,9.932.792.792,0,0,1-.9,1.006Zm4.311,5.2-.059-.013a5.656,5.656,0,0,1-3.552-2.985.791.791,0,1,1,1.451-.631,4.037,4.037,0,0,0,2.512,2.088.791.791,0,0,1-.352,1.542Z",
    transform: "translate(-271.556 -415.872)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    d: "M261.385,624.67a3.564,3.564,0,0,1-.907,4.048s.735,2.577-1.349,3.313c0,0,.55,1.721-.737,2.454a6.638,6.638,0,0,1-2.141.6l.055.073-.008.011-7.442,9.866h0L224.293,677.6c-7.232,8.65-21.315,3.228-20.878-8.039l.867-22.439h18.773l18.4-20.735a15.128,15.128,0,0,1,7.607-5.153l12.32-1.349S263.765,621.847,261.385,624.67Z",
    transform: "translate(-178.35 -481.402)",
    fill: "#dde1e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2989",
    "data-name": "Rectangle 2989",
    width: 15.148,
    height: 0.955,
    transform: "translate(35.603 177.839) rotate(-54.895)",
    fill: "#bfc7cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    d: "M205.934,698.442l17.125,2.344,1.218-2.344Z",
    transform: "translate(-180.002 -532.721)",
    fill: "#bfc7cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2036",
    "data-name": "Path 2036",
    d: "M430.608,606.961,406.77,661.323a3.824,3.824,0,0,1-2.785,2.225,110.764,110.764,0,0,1-38.4.5,3.831,3.831,0,0,1-2.883-5.325l24.376-55.469a3.826,3.826,0,0,1,4.145-2.238,116.189,116.189,0,0,0,35.348.607,3.834,3.834,0,0,1,4.038,5.336Z",
    transform: "translate(-282.198 -469.043)",
    fill: "#edf0f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    d: "M436,606.971,413.16,661.332a3.7,3.7,0,0,1-2.67,2.225,101.79,101.79,0,0,1-36.8.5,3.852,3.852,0,0,1-2.763-5.325l23.361-55.469a3.638,3.638,0,0,1,3.972-2.238,106.764,106.764,0,0,0,33.875.608A3.8,3.8,0,0,1,436,606.971Z",
    transform: "translate(-287.581 -469.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    d: "M472.538,702.9s-31.18-2.764-3.376,8.249c0,0-30.206-6.973-2.62,6.4,0,0-29.1-6.96-2.644,6.459,0,0-28.888-6.422-2.421,5.915l1.23.478a6.762,6.762,0,0,0,7.282-1.569,28.721,28.721,0,0,0,8.265-18.871,6.738,6.738,0,0,0-4.547-6.658Z",
    transform: "translate(-339.642 -535.432)",
    fill: "#dde1e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2990",
    "data-name": "Rectangle 2990",
    width: 4.099,
    height: 0.954,
    transform: "translate(78.936 142.382)",
    fill: "#bfc7cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2991",
    "data-name": "Rectangle 2991",
    width: 2.781,
    height: 0.954,
    transform: "translate(79.345 146.84)",
    fill: "#bfc7cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2992",
    "data-name": "Rectangle 2992",
    width: 2.577,
    height: 0.954,
    transform: "translate(78.2 150.152)",
    fill: "#bfc7cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2039",
    "data-name": "Path 2039",
    d: "M341.924,663.8l-7.442,9.866.873-4.807a6.26,6.26,0,0,1,6.16-5.143h.362C341.893,663.748,341.909,663.777,341.924,663.8Z",
    transform: "translate(-263.977 -510.038)",
    fill: "#bfc7cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    d: "M363.126,410.312l3.381.472-.891,6.387a58.879,58.879,0,0,1-3.107-6.983A5.107,5.107,0,0,0,363.126,410.312ZM391.3,398.234c-.187.381-.277,1.08-.873,1.191-4.849.907-13.081-.993-15.9-1.742a1.259,1.259,0,0,0-1.437.611,27.571,27.571,0,0,1-4.788,5.746.5.5,0,0,1-.838-.428l.489-3.448a.5.5,0,0,0-.379-.555l-1.315-.309a6.177,6.177,0,0,0-5.794,1.661c-.139-.663-1.344-6.931,2.823-11.113a10.576,10.576,0,0,1,4.369-2.6c6.153-3.877,13.235-4.409,17.963-1.144C389.312,388.66,393.075,394.584,391.3,398.234Z",
    transform: "translate(-280.771 -327.284)",
    fill: "#4e595f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFoundImg);
export default __webpack_public_path__ + "static/media/page-not-found-img.0a599187d17f7d4e7f7863655e0daa42.svg";
export { ForwardRef as ReactComponent };